export function openMinimap(params: any, bpmnjs: any) {
  return {
    args: [
    ],
    exec: () => {
      const isOpen = bpmnjs.get("minimap").isOpen();
      if (isOpen) {
        bpmnjs.get("minimap").close();
      } else {
        bpmnjs.get("minimap").open();
      }
    }
  };
}

openMinimap.$inject = ["cli._params", "bpmnjs"];
